import React from 'react'
import ep from './photolic/plus.jpg'
import './image.css'
const Endosementplus = () => {
  return (
    <div>
      <img src={ep} alt="" className='eimg'/>
    </div>
  )
}

export default Endosementplus
